import {mapWorkforceDashboardMetricResponse} from '../serializers/workforceDashboardSerializers';
import {
  WorkforceDashboardDepartmentHealth,
  WorkforceDashboardMetricEnvelope,
} from '../types/workforceDashboardTypes';

import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';

interface DepartmentHealthMetricState {
  data: WorkforceDashboardDepartmentHealth[] | null;
  isLoading: boolean;
  error: unknown;
}

export const useDepartmentHealthMetric = (companyId: string): DepartmentHealthMetricState => {
  const path = GetRoutes.companyWorkforceDashboardMetric(companyId, 'department_health');
  const result = useApiRead<WorkforceDashboardMetricEnvelope<WorkforceDashboardDepartmentHealth[]>>({
    path,
    camelCaseOverride: mapWorkforceDashboardMetricResponse,
    options: {
      enabled: !!companyId,
      queryKey: [path],
    },
  });

  return {
    data: result.data?.data ?? null,
    isLoading: result.isLoading,
    error: result.error,
  };
};
